import axios from 'axios'

export const session = axios.create({})

export function setAuthHeader () {
  return {
    headers: {
      Authorization: `Token ${
        localStorage.getItem(process.env.VUE_APP_TOKEN_STORAGE_KEY)
      }`
    }
  }
}
